export const ids = ['unallocated', 'internal', 'hybrid', 'external'] as const;
